import React, {Component} from "react";
import {ServerSidePaginationTable, TableButtonsBuilder} from "../../../components/Letflow/Table";
import {request} from '../../../api-client'
import localization from '../../../config/localization'
import TableButton from "../../../components/Letflow/Table/Buttons/TableButton";
import {Edit, Home, Settings} from "@material-ui/icons";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";
let table

class Table extends Component {
  state = {
    total: "",
    loaded: false,
  };

  componentDidUpdate = prevProps => {
    if (prevProps.refresh !== this.props.refresh) {
      table.forceUpdate();
    }
  };

  columns = () => [
    {
      Header: localization.get('table.name'),
      accessor: "name",
      sortable: false,
      Filter: ({filter, onChange}) => (
        <input
          onChange={event => onChange(event.target.value)}
          value={filter ? filter.value : ''}
          placeholder={localization.get('table.search')}
        />
      ),
    },
    {
      id: "actions",
      sortable: false,
      filterable: false,
      maxWidth: 140,
      accessor: section => {
        const buttonBuilder = new TableButtonsBuilder()

        buttonBuilder.withOther(
          <TableButton
            title={localization.get(section.main ? "section.is_main" : "section.make_main")}
            onClick={() => {
              if(section.main){
                GlobalSnackbar.show({
                  message: localization.get('section.is_main'),
                  type: GlobalSnackbarTypes.SUCCESS
                })
              }else {
                request.section.makeMain(section.id)
                  .then(() =>
                    GlobalSnackbar.show({
                      message: localization.get('section.update'),
                      type: GlobalSnackbarTypes.SUCCESS
                  }))
                  .then(() => table.forceUpdate())
                  .catch(() => GlobalSnackbar.showGenericError())
              }
            }}
          >
            <Home style={{color: section.main ? "green": ""}}/>
          </TableButton>
        );

        buttonBuilder.withOther(
          <TableButton
            title={localization.get("edit")}
            onClick={() => this.props.onEdit(section.id)}
          >
            <Edit />
          </TableButton>
        );

        {!section.main &&
          buttonBuilder.withDelete(
            section.name,
            () => request.section.delete(section.id),
            state => {
              if (state === "passed") {
                table.removeById(section.id)
              }
            }
          )
        }

        return buttonBuilder.build()
      }
    },
  ]

  render = () => {
    return (
      <div style={{padding: "0 15px 15px"}}>
        <ServerSidePaginationTable
          style={{width: "100%", float: "left", position: "relative"}}
          ref={r => table = r}
          columns={this.columns()}
          perPage={12}
          showPaginationBottom
          readAndWriteUrl={false}
          requestTableData={paginationConfig =>
            request.section.getAll(paginationConfig).then(response => {
              this.setState({total: response.meta.total});
              return response;
            })
          }
        />
      </div>
    )
  }
}


export default Table
